import React from "react";

interface CmBookingRecommendation {
  pet_id: string;
  pet_name: string;
  source?: string;
  [key: string]: any;
}

interface CmFollowupTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  onClose: () => void;
  cmbookingRecommendations: CmBookingRecommendation[];
  onScrollUp?: () => void;
  onScrollDown?: () => void;
  showCloseButton?: boolean;
}

const SOURCE_REASON_MAP: Record<string, string> = {
  EMR_FOLLOW_UP: "Doctor Recommended",
};

export const CmFollowupTabs: React.FC<CmFollowupTabsProps> = ({
  activeTab,
  setActiveTab,
  onClose,
  cmbookingRecommendations,
  onScrollUp,
  onScrollDown,
  showCloseButton,
}) => {
  const tabs = (cmbookingRecommendations ?? []).map((rec) => ({
    id: rec.pet_id,
    title: `${rec.pet_name}'s Next Booking`,
    reason: SOURCE_REASON_MAP[rec.source ?? ""] ?? "Doctor Recommended",
  }));

  return (
    <div
      className="bg-transparent flex items-center justify-between w-full h-[65px] shrink-0 pr-6"
      style={{

        borderImageSource: "linear-gradient(90deg, rgba(255, 255, 255, 0) 24.54%, #E0E0E0 24.66%)",
        borderImageSlice: 1,
      }}
    >
      <div className="flex overflow-x-auto flex-1 min-w-0 scrollbar-hide">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActiveTab(tab.id)}
              className={` my-2 flex items-center justify-between transition-colors duration-200 text-left w-[300px] h-[65px] shrink-0 rounded-[10px] pt-[16px] pb-[10px] px-[24px] outline-none ring-0 focus:outline-none focus:ring-0 focus-visible:outline-none active:outline-none active:ring-0 ${isActive
                ? "bg-white shadow-[0px_4px_8px_0px_rgba(0,0,0,0.08)] text-[#193A6A]"
                : "bg-[#F9F9F9] shadow-none"
                }`}
            >
              <div className="min-w-0 pr-2">
                <p
                  className={`tracking-wide truncate font-bold text-[14px] leading-[1.2] ${isActive ? "text-[#0D3880]" : "text-[#222222]"
                    }`}
                >
                  {tab.title}
                </p>
                <p className="truncate mt-0.5 font-medium text-[12px] leading-[1.2] text-[#727272]">
                  {tab.reason}
                </p>
              </div>
              <span
                className={`w-2 h-2 rounded-full shrink-0 transition-colors ${isActive ? "bg-[#1B68D3]" : "bg-[#C0C0C0]"
                  }`}
              />
            </button>
          );
        })}
      </div>

      <div className="flex items-center gap-2 ml-3 shrink-0">
        {onScrollUp && (
          <button
            type="button"
            onClick={onScrollUp}
            aria-label="Scroll up"
            className="h-9 w-9 flex items-center justify-center rounded-lg border border-blue-200 bg-white text-blue-600 shadow-sm hover:bg-blue-50 hover:shadow-md active:scale-95 transition focus:outline-none"
          >
            <svg viewBox="0 0 20 20" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12.5l5-5 5 5" />
            </svg>
          </button>
        )}
        {onScrollDown && (
          <button
            type="button"
            onClick={onScrollDown}
            aria-label="Scroll down"
            className="h-9 w-9 flex items-center justify-center rounded-lg border border-blue-200 bg-white text-blue-600 shadow-sm hover:bg-blue-50 hover:shadow-md active:scale-95 transition focus:outline-none"
          >
            <svg viewBox="0 0 20 20" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 7.5l5 5 5-5" />
            </svg>
          </button>
        )}
        {showCloseButton && (
          <button
            type="button"
            onClick={onClose}
            className="p-1 shrink-0 rounded-full text-slate-400 hover:text-slate-600 transition-colors focus:outline-none flex items-center justify-center"
          >
            <img src="/cross_vector.svg" alt="Close" className="w-[19px] h-[19px]" />
          </button>)}
      </div>
    </div>
  );
};

